<div class="start-end-container" [class.opened]="true">
  <div class="start-target-values">
    <div class="value value-start">
      <label>
        {{ translation.wayfinding.start | transloco }}
      </label>

      @if (hasStart()) {
        @if (startResourceDetail.hasValue()) {
          <div class="flex gap-3">
            <button
              (click)="wantChangeState.emit(navigationStateEnum.StartSelection)"
              data-cy="navigation-start-input"
              class="start-target-input grow"
              [class.error]="startInputError()"
            >
              <span class="value-wrapper" data-cy="start-detail-input">
                <cue-icon [icon]="ICONS.cueStart" />
                {{
                  (startResourceDetail.value().displayNameForApp | localizedString) && startResource().resourceId
                    ? (startResourceDetail.value().displayNameForApp | localizedString)
                    : (startResourceDetail.value().name | localizedString)
                }}
              </span>
              @if (!isKiosk()) {
                @if (startResourceDetail.hasValue()) {
                  <cue-icon (click)="deleteStart($event)" [icon]="ICONS.cueClose" class="close-search" />
                } @else {
                  <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
                }
              }
            </button>
            @if (!isKiosk() && responsiveService.isNavigationMobileMode()) {
              <button (click)="scanStartSelection.emit()" class="primary scan-btn" type="button">
                <cue-icon [icon]="ICONS.cueQrCode" />
              </button>
            }
          </div>
          <assist-resource-detail
            (requestOpenMapItemDetail)="openMapItemDetail($event, true)"
            [resourceDetail]="startResourceDetail.value()"
            [loading]="startResourceDetail.isLoading()"
          />
        } @else {
          <div class="flex gap-3">
            <button
              (click)="wantChangeState.emit(navigationStateEnum.StartSelection)"
              data-cy="navigation-start-input"
              class="start-target-input grow"
              [class.highlighted]="!startInputError()"
              [class.error]="startInputError()"
            >
              <span class="value-wrapper">
                <cue-icon [icon]="ICONS.cueStart" />
                <span [class.placeholder]="!startInputError()" data-cy="start-detail-input">
                  {{ translation.wayfinding.selectStartLocation | transloco }}
                </span>
              </span>
              @if (routeSearchResult()?.start === startTargetResultEnum.Found) {
                <cue-icon [icon]="ICONS.cueClose" class="close-search" />
              } @else {
                <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
              }
            </button>
            @if (!isKiosk() && responsiveService.isNavigationMobileMode()) {
              <button (click)="scanStartSelection.emit()" class="primary scan-btn" type="button">
                <cue-icon [icon]="ICONS.cueQrCode" />
              </button>
            }
          </div>
        }
      } @else {
        <div class="flex gap-3">
          <button
            (click)="wantChangeState.emit(navigationStateEnum.StartSelection)"
            data-cy="navigation-start-input"
            class="start-target-input grow"
            [class.highlighted]="!startInputError()"
            [class.error]="startInputError()"
          >
            <span class="value-wrapper">
              <cue-icon [icon]="ICONS.cueStart" />
              <span [class.placeholder]="!startInputError()" data-cy="start-detail-input">
                {{ translation.wayfinding.selectStartLocation | transloco }}
              </span>
            </span>
            @if (routeSearchResult()?.start === startTargetResultEnum.Found) {
              <cue-icon [icon]="ICONS.cueClose" class="close-search" />
            } @else {
              <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
            }
          </button>
          @if (!isKiosk() && responsiveService.isNavigationMobileMode()) {
            <button (click)="scanStartSelection.emit()" class="primary scan-btn" type="button">
              <cue-icon [icon]="ICONS.cueQrCode" />
            </button>
          }
        </div>
      }
    </div>
    <hr />
    <div class="flex">
      <div class="switch-start-target" [class.error]="routeConnectorError()" (click)="requestSwitchStartTarget.emit()">
        <cue-icon [icon]="ICONS.cueArrowsUpDown" />
      </div>
      <div class="z-[9] text-[--text-danger] px-3 flex items-center gap-2" style="--cue-icon-color: var(--text-danger)">
        @if (routeErrorMessage()) {
          <cue-icon class="scale-90" [icon]="ICONS.cueWarning" />
        }
        <span class="leading-[0] text-sm">{{ routeErrorMessage() | transloco }}</span>
      </div>
    </div>
    <hr />
    <div class="value">
      <label>
        {{ translation.wayfinding.target | transloco }}
      </label>
      @if (hasTarget()) {
        @if (targetResourceDetail.hasValue()) {
          <div
            (click)="wantChangeState.emit(navigationStateEnum.TargetSelection)"
            data-cy="navigation-target-input"
            class="start-target-input"
            [class.error]="targetInputError()"
          >
            <span class="value-wrapper" data-cy="target-detail-input">
              <cue-icon [icon]="ICONS.cueTarget" />
              {{
                ((targetResourceDetail.value().displayNameForApp | localizedString) && targetResource()
                  ? (targetResourceDetail.value().displayNameForApp | localizedString)
                  : (targetResourceDetail.value().name | localizedString)) || targetResourceCategoryName
              }}
            </span>
            @if (targetResourceDetail.hasValue()) {
              <cue-icon (click)="deleteTarget($event)" [icon]="ICONS.cueClose" class="close-search" />
            } @else {
              <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
            }
          </div>
          <assist-resource-detail
            (requestOpenMapItemDetail)="openMapItemDetail($event, false)"
            [resourceDetail]="targetResourceDetail.value()"
            [loading]="targetResourceDetail.isLoading()"
          />
        } @else {
          <div
            (click)="wantChangeState.emit(navigationStateEnum.TargetSelection)"
            data-cy="navigation-target-input"
            class="start-target-input"
            [class.highlighted]="!targetInputError()"
            [class.error]="targetInputError()"
          >
            <span class="value-wrapper">
              <cue-icon [icon]="ICONS.cueTarget" />
              <span [class.placeholder]="!targetInputError()" data-cy="target-detail-input">
                {{ targetResourceCategoryName() || (translation.wayfinding.selectTargetLocation | transloco) }}
              </span>
            </span>
            @if (routeSearchResult()?.target === startTargetResultEnum.Found) {
              <cue-icon [icon]="ICONS.cueClose" class="close-search" />
            } @else {
              <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
            }
          </div>
        }
      } @else {
        <div
          (click)="wantChangeState.emit(navigationStateEnum.TargetSelection)"
          data-cy="navigation-target-input"
          class="start-target-input"
          [class.highlighted]="!targetInputError()"
          [class.error]="targetInputError()"
        >
          <span class="value-wrapper">
            <cue-icon [icon]="ICONS.cueTarget" />
            <span [class.placeholder]="!targetInputError()" data-cy="target-detail-input">
              {{ targetResourceCategoryName() || (translation.wayfinding.selectTargetLocation | transloco) }}
            </span>
          </span>
          <cue-icon [icon]="ICONS.cueEdit" class="edit-icon" />
        </div>
      }
    </div>
  </div>

  @if (showRouteOverview()) {
    <hr />
    <section class="route-overview">
      <h2>
        <cue-icon [icon]="ICONS.cueMap" />
        {{ translation.navigation.routeOverview | transloco }}
      </h2>

      <assist-navigation-route-overview
        layout="vertical"
        [showNotes]="true"
        [areaId]="areaId()"
        [groupIdx]="groupIdx()"
        [navBarData]="navBarData()"
        [routeOverviewNotes]="routeOverviewNotes()"
        (requestMoveToSpecificArea)="requestMoveToSpecificArea.emit($event)"
        (routeOverviewNoteClick)="routeOverviewNoteClick.emit($event)"
      />
    </section>
  }
</div>
